<template>
  <span v-if="!task.discarded">
    <i class="material-icons pointer ml-1" data-toggle="modal" :data-target="'#contactsModal' + task.id">contacts</i>
    <div class="modal fade" :id="'contactsModal' + task.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Assistants</h5>
            <button type="button" class="btn btn-inverse pull-right" data-dismiss="modal" @click="saveContacts()">Done</button>
          </div>
          <div class="modal-body">
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="newContact" v-on:keyup.enter="addContact" placeholder='New Assistant'>
              <div class="input-group-append">
                <button class="btn btn-primary" type="button" @click="addContact">Add Assistant</button>
              </div>
            </div>

            <ul class="mt-2 list-group">
              <li v-for="contact in this.activeContacts()" class="list-group-item pointer" @click="toggleContact(contact.id)">
                <span>
                  <i v-if="contactAttached(contact)" class="material-icons bottom-align text-primary">contacts</i>
                  <i v-else class="material-icons-outlined bottom-align text-primary">contacts</i>
                  <span class="text-muted">{{contact.name}}</span>
                </span>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveContacts()">Done</button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
var firstBy = require('thenby');
import api from "api";

export default {
  data() {
    return {
      selectedContactIds: this.task.formatted_contact_list.split(',').map(Number),
      // allContacts: this.$store.state.user_contacts,
      // parsedContacts: Object.assign({}, ...window.store.state.user_contacts.map(data => ({[data.id]: data.name}))),
      newContact: '',
      // activeContacts: this.$store.state.getters.sortedActiveContacts,
    };
  },
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    activeContacts(){
      return store.getters.sortedActiveContacts
    },
    saveContacts(){
      var router = this.$router

      var message = this.$t('contacts.plural') + ' updated for ' + this.task.title
      var task = this.task

      api.updateTaskContacts(this.task.id, { title: this.task.title, contacts: this.selectedContactIds }).then(response => {
        $('#contactsModal' + this.task.id).modal('hide');
        $('body').removeClass('modal-open');
        $(".modal-backdrop").hide();
        this.foundContacts = [];

        if(this.selectedContactIds.length > 0){
          this.$router.push({ name: 'contact', params: { contact_id: this.selectedContactIds[this.selectedContactIds.length - 1] } }) 
        } else {
          router.push({ name: 'todo', params: { task_id: task.id } })
        }
      });
    },
    toggleContact(contact_id){
      if(this.selectedContactIds.includes(contact_id)){
        // Remove Contact
        var index = this.selectedContactIds.indexOf(contact_id)
        this.selectedContactIds.splice(index, 1);

        store.commit('removeFromSortedGroup', {
          taskId: this.task.id,
          groupName: 'contactId' + contact_id
        })
      } else {
        // Add Contact
        this.selectedContactIds.push(contact_id)

        store.commit('addToSortedGroup', {
          taskId: this.task.id,
          groupName: 'contactId' + contact_id
        })
      }
    },
    contactAttached(contact){
      return this.selectedContactIds.includes(contact.id)
    },
    addContact(){
      var contact_name = this.newContact.trim().replace(/\//g, "-")
 
      api.createContact(contact_name).then(response => {
        this.toggleContact(response.data.id)
        this.newContact = ''

        store.commit('addIdToSortedGroup', { name: 'contacts', id: response.data.id })

        // this.activeContacts()
      });
    },
  }
}
</script>
